import {LunarYear} from '../../LunarYear'
import moment from 'moment-timezone'

const Y1957 = new LunarYear(
  moment.tz('1957-01-31 00:00', 'Asia/Seoul'),
  [1, 2, 3, 4, 5, 6, 7, 8, 8, 9, 10, 11, 12],
  [30, 29, 30, 29, 30, 29, 29, 30, 29, 30, 29, 30, 30],
  8,
)

export default Y1957
